import { getAbilityData } from '../../../shared/content/AbilityDataAdapter';
import { isSelfDamageField, readSelfDamageField, type SelfDamageField } from '../../../shared/combat/selfDamageBuffs';
import type { StatusVFXEvent } from './PendingStatusVFX';

/** Undefined: ordinary body-following status. Null: a field without valid
 * placement must wait/drop, never silently draw on the caster. */
export function statusWorldPlacement(data: StatusVFXEvent): SelfDamageField | null | undefined {
  if (!data.abilityId || !isSelfDamageField(data.abilityId)) return undefined;
  const field = readSelfDamageField(data.data?.worldField);
  return field && field.radius === getAbilityData(data.abilityId)?.radius ? field : null;
}
